import { render, staticRenderFns } from "./HeartService.vue?vue&type=template&id=0f62918b"
import script from "./HeartService.vue?vue&type=script&lang=js"
export * from "./HeartService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports